import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href="mailto:support@atero.io" target="_blank" rel="noopener noreferrer">Contact</a>
        </li>
        <li>
          <a href="//linkedin.com/company/aterocommerce" target="_blank" rel="noopener noreferrer">About Us</a>
        </li>
        {/*<li>
          <Link to="/faqs/">FAQ's</Link>
        </li>
        <li>
          <Link to="/support/">Support</Link>
        </li>*/}
      </ul>
    </nav>
  );
}

export default FooterNav;
